<template>
    <div class="slide-title" :class="{'slide-title--right': slide.frontSlide }">
      <h1>
        <cmslink v-if="showSlideShow && slide.link" :link="slide"/>
        <span v-else>{{slide.title}}</span>
      </h1>
      <!--<h1 v-for="row in rows">
        <cmslink v-if="showSlideShow && slide.link" :link="{url: slide.url, title: row}"/>
        <span v-else>{{row}}</span>
      </h1> -->
    </div>
</template>

<script>
  export default {
    data() {
      return {
        rows: [],
      }
    },
    mounted() {
      const words = this.slide.title.split(' ');
      const rows = words.reduce((acc, current) => {
        if (acc.length > 0 && acc[acc.length - 1].length + current.length + 1 < 38) {
          acc[acc.length - 1] = `${acc[acc.length - 1]}  ${current}`;
          return acc;
        }
        acc.push(current);
        return acc;
      }, []);
      this.rows = rows;
    },
    props: ['showSlideShow', 'slide'],
  };
</script>

